import { render, staticRenderFns } from "./Navbar.template.vue?vue&type=template&id=005ed900&scoped=true&"
var script = {}
import style0 from "./Navbar.template.vue?vue&type=style&index=0&id=005ed900&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005ed900",
  null
  
)

export default component.exports